<template>
  <div class="dashboard-page">
    <h1 class="page-title">Dashboard</h1>
    <div class="sidesWrapper">
      <div style="width: 100%">
        <b-tabs nav-class="bg-transparent">
          <b-tab title="Pengendalian" active>
            <div class="d-flex gap-2">
              <div>
                <select v-model="filter_tahun" id="filter_tahun1" class="form-select">
                  <option v-for="d in optionTahun" :value="d">{{ d }}</option>
                </select>
              </div>
              <div>
                <select v-model="filter_bulan" id="filter_bulan1" class="form-select" aria-label="Filter bulan">
                  <option value="all">Semua Bulan</option>
                  <option v-for="(bulan, index) in optionBulan" :key="index" :value="String(index + 1)">
                    {{ bulan }}
                  </option>
                </select>
              </div>
            </div>

            <MainChartPemohon :filter-tahun="filter_tahun" :filter-bulan="filter_bulan" />

            <div class="row mt-4 g-3">
              <div class="col-12">
                <HasilPenilaianChart :filter-tahun="filter_tahun" :filter-bulan="filter_bulan" />
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import HasilPenilaianChart from './HasilPenilaianChart.vue'
import MainChartPemohon from './MainChartPemohon.vue'

export default {
  components: {
    MainChartPemohon,
    HasilPenilaianChart,
  },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      filter_tahun: new Date().getFullYear(),
      filter_bulan: 'all',
    }
  },
  computed: {
    optionTahun() {
      const currentYear = new Date().getFullYear()
      return Array.from({ length: 10 }, (_, i) => currentYear - i)
    },
    optionBulan() {
      return ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
    },
  },
}
</script>
